import axios from 'axios';
import {
  SalesFeeGetAllResponse,
  SalesFeeGetActiveFeeResponse,
  SalesFeeAddMutationRequest,
  SalesFeeGetOneResponse,
  SalesFeeUpdateMutationRequest,
} from '../../types';
import { initialDataSalesFeeActive } from '../../hooks';

class SalesFeeService {
  getAll = (props: any) => axios.get<SalesFeeGetAllResponse>('/sales-fee', props);

  get = (id: string) => axios.get<SalesFeeGetOneResponse>(`/sales-fee/${id}`);

  getActiveFee = (yardId: string) =>
    axios
      .get<SalesFeeGetActiveFeeResponse>(`/sales-fee/${yardId}/active`)
      .then((res) => res.data)
      .then((res) =>
        res.data.containers.reduce<Record<string, any>>((acc, item) => {
          if (!acc.feeType) acc.feeType = res.data.feeType;

          acc[item.type] = Number(item.fee);
          return acc;
        }, {}),
      )
      .catch(() => initialDataSalesFeeActive);

  add = ({ id, ...props }: SalesFeeAddMutationRequest) => axios.post(`/sales-fee/${id}`, props);

  update = ({ id, ...props }: SalesFeeUpdateMutationRequest) =>
    axios.patch(`/sales-fee/${id}`, props);
}

export const salesFeeService = new SalesFeeService();
